import React, { useEffect, useState, useContext } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axios from 'axios';
import { Container } from '@mui/system';
import Grid from '@mui/material/Grid';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import LoaderDialog from './LoaderDialog'
import { AuthContext } from '../authContext/AuthContext'
import { BarChart } from '@mui/x-charts/BarChart';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const MaxSellPerHourReport = ({startDate, endDate, shopKeys}) => {
  const [data, setData] = useState();
  const [series, setSeries] = useState();
  const [dataset, setDataset] = useState();
  const [loading, setLoading] = useState(false)
  const { user, shop } = useContext(AuthContext);
  useEffect(() => {
    const loadData = async() => {
      setLoading(true)
      try {
        const columns = [
          {"field": "id", "headerName": "#", "key":"aa"}, 
          {"field": "date", "headerName": "Date"},
          {"field": "hour", "headerName": "Hour"},
          {"field": "total", "headerName": "Total Sell"}
        ]
        let d = new Date(endDate)
        d.setDate(d.getDate() + 1)
        const newEndDate = d.toISOString().split('T')[0]
        let datas = {}
        let dataset_bar = {}
        let bar_series = {}
        for(let index in shopKeys) {
          const key = shopKeys[index]
          const res = await axios.post("/orders/maxSellPerHourReport", {startDate, endDate: newEndDate, shopKeys: [key]}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
          const sortedData = res.data.sort((a,b) => {return a._id.hour - b._id.hour});
          
          let sd = []
          let sd3 = {}
          let sd1 = []
          let dp = []
          sortedData.forEach((res, index)=> {
            sd.push({"id": index + 1, "date": res._id.day + "-"+ res._id.month +"-" + res._id.year,"hour": res._id.hour, "total": res.total})
            const da = res._id.day + "/" + res._id.month + "/" + res._id.year
            if(!sd3[res._id.hour]) {
              sd3[res._id.hour] = []
            }
            sd3[res._id.hour][da] = res.total
            if(!dp[da]){
              dp[da] = true
              sd1.push({ dataKey: da, label: da, valueFormatter })
            }
          })
          datas[key] = {"rows": sd, "columns": columns}
          bar_series[key] = sd1

          let sd4 = []
          for (const val in sd3) {
            sd3[val]['hour'] = val
            sd4.push(sd3[val])
          }
          dataset_bar[key] = sd4
        }
        setData(datas)
        setSeries(bar_series)
        setDataset(dataset_bar)
        console.log(datas)
        console.log(dataset_bar)
        console.log(bar_series)

        setLoading(false)
      } catch (err) {
        console.log(err)
        setLoading(false)
      }
    }
    loadData();
  },[startDate, endDate, user, shop, shopKeys]);

  const valueFormatter = (value) => `${value}`;
  
  return (   
    <Container maxWidth="false" disableGutters sx={{height: "70vh", width: "100vw"}}>       
      <LoaderDialog open={loading} title="Loading Report Data ..."/>
      {shopKeys && dataset && series && shopKeys.map((key, index) => <>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id={index}
          >
            {key}
          </AccordionSummary>
          <AccordionDetails>
            <Grid container>
              <Grid item xs={9}>
                <BarChart
                dataset={dataset[key]}
                series={series[key]}
                xAxis={[{ scaleType: 'band', dataKey: 'hour' }]}
                width="1300"
                height="650"
                />
              </Grid>
              <Grid item xs={3}>
                {data && <DataGrid {...data[key]} components={{ Toolbar: GridToolbar }} sx={{height: "70vh"}}/>}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </>)}
      
    </Container>
  )
}

export default MaxSellPerHourReport
